import { types } from './types';

const INITIAL_STATE = {
  entregador: {},
  loaded: false,
  error: false,
  errorData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ENTREGADOR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}